<script setup lang="ts">
import SiteMapMinersTable from '@/components/eos/site-map/SiteMapMinersTable.vue'
</script>

<template>
  <SiteMapMinersTable> </SiteMapMinersTable>
</template>
